(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('SocialInsurance', SocialInsurance);

    SocialInsurance.$inject = ['$resource'];

    function SocialInsurance ($resource) {
        var resourceUrl =  'api/social-insurances/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
